import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import api from "../../AxiosHelper";
import { MIDDLE_CREDENTIAL, storeAssigned, _setTimeOut } from "../../Methods/normalMethods";
import { getCurrencyCode } from "../../Methods/normalMethods";

const PaymentSlice = createSlice({
    name: "productSlice",
    initialState: {
        paymentOptions: [],
        paymentFormHtml: "",
        paymentScript: "",
        paymentError: "",
        iframeLoader: false,
    },
    reducers: {
        setPaymentOptions: (state, actions) => { state['paymentOptions'] = actions?.payload; },
        setFormHtml: (state, actions) => { state['paymentFormHtml'] = actions.payload; },
        setScriptFunction: (state, actions) => { state['paymentScript'] = actions.payload; },
        setIframeLoader: (state, action) => { state['iframeLoader'] = action?.payload },
        setPaymentError: (state, action) => { state['paymentError'] = action.payload },
    }
});
export const { setPaymentOptions, setFormHtml, setScriptFunction, setIframeLoader, setPaymentError } = PaymentSlice?.actions;

export const _getPaymentOptions = (callback) => dispatch => {
    dispatch(setPaymentError(''));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({
        method: "GET",
        // getCurrencyCode(CURRENT_STORE)
        endpoint: `/Money/PaymentOptions/${_.upperCase(storeAssigned())}/${getCurrencyCode(_.upperCase(storeAssigned()))}`
    }).success((res) => {
        if (res?.data?.length > 0) {
            dispatch(setPaymentOptions(res?.data))
            callback(res?.data)
        }
    }).error((err) => {
        dispatch(setPaymentError(err?.errorMessage));
    }).send();
}

export const _getPaymentHtml = (paymentOptionId, data = null) => dispatch => {
    dispatch(setPaymentError(''));
    dispatch(setIframeLoader(true));
    api().setHeaders(MIDDLE_CREDENTIAL).post().data({
        method: "POST",
        endpoint: `/Money/PaymentOptions/Form`,
        data: JSON.stringify({
            "paymentOptionId": paymentOptionId,
            "frameId": "collect_form_pay",
            "formSubmitFunctionName": 'submitHandle',
            "onSuccessFunctionName": 'onSucessFunciton',
            "onErrorFunctionName": 'onErrorFunction',
            "url": window.location.origin,
            // "url": "http://localhost:3000",
            "customCSS": "string"
        })
    }).success((res) => {
        if (res?.data) {
            dispatch(setScriptFunction(res?.data?.scriptRaw))
            dispatch(setFormHtml(res?.data?.frameSource));
            _setTimeOut(() => dispatch(setIframeLoader(false)), 4000);
        } else {
            dispatch(setIframeLoader(false));
        }
    }).error((err) => {
        dispatch(setIframeLoader(false));
        dispatch(setPaymentError(err?.errorMessage));
    }).send();
}


export default PaymentSlice?.reducer;